import React from 'react'

import withDefaultStyles from './withDefaultStyles'

/**
 * Dual-circle AI badge used in the system-notifications bell for credit alerts
 * (Figma PLG Flow 3.1 — "Your team is out of AI credits").
 * Brand illustration: keep navy + white across light/dark themes.
 */
const AiCreditsBell = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="28"
    height="28"
    viewBox="0 0 28 28"
    fill="none"
    aria-hidden
  >
    {/* Offset ring behind the filled badge */}
    <circle cx="11.5" cy="11.5" r="9" stroke="#223063" strokeWidth="1.75" fill="none" />
    {/* Front badge */}
    <circle cx="16.5" cy="16.5" r="9.5" fill="#223063" />
    {/* White 4-point sparkle */}
    <path
      d="M16.5 10.2C16.78 11.55 17.7 12.47 19.05 12.75C17.7 13.03 16.78 13.95 16.5 15.3C16.22 13.95 15.3 13.03 13.95 12.75C15.3 12.47 16.22 11.55 16.5 10.2Z"
      fill="#fff"
    />
  </svg>
)

export default withDefaultStyles(AiCreditsBell)
